import { useNotificationToasts } from '../hooks'

/**
 * Invisible component that listens for new notifications and shows toast popups.
 * Rendered once at the app root level inside AppProviders.
 */
export function NotificationToastListener() {
  useNotificationToasts()
  return null
}
